import { useEffect } from "react";
import { motion, stagger, useAnimate } from "framer-motion";
import { cn } from "../lib/utils";

const TextGenerator = ({ words, className }: { words: string; className?: string }) => {
	const [scope, animate] = useAnimate();
	let wordsArray = words.split(" ");
	useEffect(() => {
		animate(
			"span",
			{
				opacity: 1,
			},
			{
				duration: 2,
				delay: stagger(0.2),
			}
		);
	}, [animate]);

	const renderWords = () => {
		return (
			<motion.div ref={scope}>
				{wordsArray.map((word, idx) => {
					return (
						<motion.span key={word + idx} className='text-neutral-200 opacity-0 lg:text-3xl text-xl'>
							{word}{" "}
						</motion.span>
					);
				})}
			</motion.div>
		);
	};

	return (
		<div className={cn("text-center", className)}>
			<div className='mt-4'>
				<div className='leading-snug tracking-wide'>{renderWords()}</div>
			</div>
		</div>
	);
};

export default TextGenerator;
